import React, { useState, useEffect } from "react";
import { Container, TextField, Button, Typography, Box, Paper } from "@mui/material";
import axios from "axios";

export default function ProfilePage() {
  const [profile, setProfile] = useState({
    name: "",
    email: "",
    phone: "",
    department: "",
    designation: "",
    address: "",
    dob: "",
    nativePlace: "",
    class10Marks: "",
    interMarks: "",
    graduationMarks: "",
    panCard: "",
    aadhaar: "",
    bloodGroup: ""
  });

  useEffect(() => {
    axios.get("http://65.1.112.73:5000/profiles/1") // Assuming ID is 1 for now
      .then(response => {
        if (response.data) {
          setProfile(response.data);
        }
      })
      .catch(error => console.error("Error fetching profile:", error));
  }, []);

  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios.post("http://65.1.112.73:5000/profiles", profile)
      .then(() => alert("Profile updated successfully"))
      .catch(error => console.error("Error updating profile:", error));
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ padding: 3, mt: 5, textAlign: "center" }}>
        <Typography variant="h5" gutterBottom>
          Employee Profile
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <TextField fullWidth label="Full Name" variant="outlined" margin="normal" name="name" value={profile.name} onChange={handleChange} required />
          <TextField fullWidth label="Email" variant="outlined" margin="normal" name="email" type="email" value={profile.email} onChange={handleChange} required />
          <TextField fullWidth label="Phone Number" variant="outlined" margin="normal" name="phone" type="tel" value={profile.phone} onChange={handleChange} required />
          <TextField fullWidth label="Date of Birth" variant="outlined" margin="normal" name="dob" type="date" value={profile.dob} onChange={handleChange} required />
          <TextField fullWidth label="Native Place" variant="outlined" margin="normal" name="nativePlace" value={profile.nativePlace} onChange={handleChange} required />
          <TextField fullWidth label="10th Class Marks" variant="outlined" margin="normal" name="class10Marks" type="number" value={profile.class10Marks} onChange={handleChange} required />
          <TextField fullWidth label="Inter Marks" variant="outlined" margin="normal" name="interMarks" type="number" value={profile.interMarks} onChange={handleChange} required />
          <TextField fullWidth label="Graduation Marks" variant="outlined" margin="normal" name="graduationMarks" type="number" value={profile.graduationMarks} onChange={handleChange} required />
          <TextField fullWidth label="PAN Card Number" variant="outlined" margin="normal" name="panCard" value={profile.panCard} onChange={handleChange} required />
          <TextField fullWidth label="Aadhaar Number" variant="outlined" margin="normal" name="aadhaar" value={profile.aadhaar} onChange={handleChange} required />
          <TextField fullWidth label="Blood Group" variant="outlined" margin="normal" name="bloodGroup" value={profile.bloodGroup} onChange={handleChange} required />
          <TextField fullWidth label="Department" variant="outlined" margin="normal" name="department" value={profile.department} onChange={handleChange} />
          <TextField fullWidth label="Designation" variant="outlined" margin="normal" name="designation" value={profile.designation} onChange={handleChange} />
          <TextField fullWidth label="Address" variant="outlined" margin="normal" name="address" multiline rows={3} value={profile.address} onChange={handleChange} />
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 2 }}>
            Save Profile
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
